import { useUserStore } from '@Auth/store';
import { teamQueries } from '@queries/fetchTeams';
import { useQuery } from '@tanstack/react-query';
import { isPreDraftContractPath, isSubmissionPath } from '@utils/app-paths';

export const useUserTeams = () => {
  const isSubmission = isSubmissionPath() || isPreDraftContractPath();
  const user = useUserStore(({ user }) => user);

  const userHasNoTeams = (user?.tenantIds?.length ?? 0) === 0;
  const shouldShowAllTeams = !isSubmission || (isSubmission && userHasNoTeams);

  const allTeamsQuery = useQuery({ ...teamQueries.list(), enabled: shouldShowAllTeams });
  const userTeamsQuery = useQuery({ ...teamQueries.forUser(user?.tenantIds ?? []), enabled: !shouldShowAllTeams });

  return {
    data: shouldShowAllTeams ? (allTeamsQuery.data ?? []) : (userTeamsQuery.data ?? []),
    isFetching: shouldShowAllTeams ? allTeamsQuery.isFetching : userTeamsQuery.isFetching,
    isLoading: shouldShowAllTeams ? allTeamsQuery.isLoading : userTeamsQuery.isLoading,
  };
};
